import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../services/Api';
import { authHeader } from '../services/auth-header';

const ImageUpload = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select a file!',
      });
      return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await axios.post(BASE_URL + 'drawing/upload', formData, {
        headers: authHeader(),
        'Content-Type': 'multipart/form-data'
      });

      const uploadedFile = {
        name: response.data.name,
        url: response.data.url
      };

      setUploadedFiles([...uploadedFiles, uploadedFile]);

      // Clear file input after successful upload
      setFile(null);

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'File uploaded successfully!',
      }).then(() => {
        navigate('/imagetabledindex/1');
      })
    } catch (error) {
      console.error('File upload error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response.data,
      });

    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>UPLOAD DRAWING FILE</h6>
          <Link to="/imagetabledindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <div>
            <input className='form-control' type="file" onChange={handleFileChange} />
            <button className='button-70' onClick={handleUpload}>Upload PDF</button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ImageUpload;
